import React from 'react';

const BigModal = ({ children }) => {
    return (
        <div className="page-modal">
            {children}
        </div>
    )
}

export default BigModal;
